import styled from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';

interface Props {
  transition: boolean;
  width: number;
}

export const Wrapper = styled.div`
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-transform: translateZ(0);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 2000;
  top: 0;
  right: ${(props: Props) => props.transition
    ? '0'
    : '-100%'};
  transition: all .4s ease;
  background-color: #FFFFFF;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    max-width: 527px;
    right: ${(props: Props) => props.transition
    ? '0'
    : '-527px'};
  }
`;

export const HeaderWrapper = styled.div`
  box-sizing: border-box;
  padding: 10px 21px 11px 21px;
  width: 100%;
  display: flex;
  min-height: 56px;
  flex-direction: row;
  align-items: center;
  background: ${COLORS.WHITE_DARK};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  position: sticky;
  z-index: 3000;
  top: 0;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: 80px;
    padding: 18px 21px 19px 21px;
  }
`;

export const Title = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 14px;
  line-height: 19px;
  margin-left: 21px;
  font-weight: bold;
  color: #000000;

  span {
    display: block;
    color: ${COLORS.GRAY_TEXT};
    font-weight: normal;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
    line-height: 25px;
  }
`;

export const IconWraper = styled.div`
  cursor: pointer;
`;

export const ShadowBackGround = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: ${(props: Props) => props.transition && '#000000'};
  opacity: 0.5;
  transition: all .4s ease;
  pointer-events: ${(props: Props) => props.transition
    ? 'auto'
    : 'none'};
`;